import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import { styles } from "../ReactPdfStyles";

const headerStyles = StyleSheet.create({
	headerContainer: {
		width: "75%",
		left: 0,
		top: 0,
		textAlign: "left",
		fontSize: 14,
		fontWeight: "bold",
	},
});

function PdfHeader({
	reportTitle,
	data,
	reportLogo,
}: {
	reportTitle: string;
	data: {
		internal_report: boolean | undefined;
		report_number: string;
		title: string;
	};
	reportLogo?: string;
}) {
	const { internal_report, report_number, title } = data;

	return (
		<View
			fixed
			style={[
				styles.headerContainer,
				{ flexDirection: "row", justifyContent: "space-between" },
			]}
		>
			<View>
				<Text style={styles.reportType} wrap={false}>
					{reportTitle}
				</Text>
				<Text style={headerStyles.headerContainer}>
					{internal_report !== undefined &&
						(internal_report ? "[INTERNAL] " : "[GLOBAL] ")}{" "}
					{report_number} {title}
				</Text>
			</View>
			<View style={{ justifyContent: "center" }}>
				<Image style={{ height: 35 }} src={reportLogo} />
			</View>
		</View>
	);
}

export default PdfHeader;
